import React from 'react';
import logo from "../assets/images/Logo.jpeg"
import { Container } from 'react-bootstrap';
import '../css/legalPages.css';

const PrivacyPolicy = () => {
    return (
        <div className="bw-legal-page"><Container className="bw-legal-container">
            <div className='PrivacyPolicyMainCont'>
                <div className="sidebar-logoContainer">
                    <div style={{ width: 120, height: 120, borderRadius: 120, padding: 20, backgroundColor: "#ad0a1d", }}>
                        <img src={logo} alt="logo" className='LandingLogo' />
                    </div>
                </div>
                <h4 style={{ textAlign: "center", margin: 20 }}>Privacy Policy</h4>
                <p>We value the trust you place in us and recognize the importance of secure transactions and information privacy.
                    This Privacy Policy describes how Buyandwin Internet Private Limited and its affiliates (collectively “Buyandwin,
                    we, our, us”) collect, use, share or otherwise process your personal data through buyandwin mobile application,
                    (hereinafter referred to as the “Platform”).While you can browse sections of the Platform without the need of
                    sharing any information with us, however, please note we do not offer any product or service under this Platform
                    outside India and your personal data will primarily be stored and processed in India. By visiting this Platform,
                    providing your information or availing out product/service, you expressly agree to be bound by the terms and
                    conditions of this Privacy Policy, the terms of use and the applicable service/product terms and conditions,
                    and agree to be governed by the laws of India including but not limited to the laws applicable to data protection
                    and privacy. If you do not agree please do not use or access our Platform.</p>

                <h4>Information We Collect </h4>
                <p>We collect personal information such as your name, email address, and payment details when
                    you place an order or sign up for our newsletter.</p>
                <h4>How We Use Your Information </h4>
                <p>We use your information to process your orders, communicate with you, and improve our
                    Services.</p>
                <h4>Cookies </h4>
                <p>We use cookies to personalize content, analyze our traffic, and improve your browsing
                    Experience.</p>
                <h4>Data Security </h4>
                <p>We take precautions to protect your information both online and offline.</p>
                <h4>Changes to This Privacy Policy </h4>
                <p>We reserve the right to update or change our Privacy Policy at any time.</p>
                <h4>Advertisements on Platform</h4>
                <p>We use third-party advertising companies to serve ads when you visit our Platform. These companies may use information
                    (not including your name, address, email address, or telephone number) about your visits to this and other websites
                    in order to provide personalized advertisements about goods and services of interest to you.</p>
                <h4>Links to Other Sites</h4>
                <p>Our Platform may provide links to other websites or applications that may collect personal data about you and you will 
                    be governed by their privacy policies. buyandwin shall not be responsible for the privacy practices or the content 
                    of their privacy policies, and we request you to read their privacy policies prior to disclosing any information.</p>
                    <h4>Your Consent</h4>
                <p>By visiting our Platform or by providing your personal data, you consent to the collection, use, storage, disclosure 
                    and otherwise processing of your personal data on the Platform in accordance with this Privacy Policy. If you 
                    disclose to us any personal data relating to other people, you represent that you have the authority to do so and 
                    to permit us to use the data in accordance with this Privacy Policy. You, while providing your personal data over 
                    the Platform or any partner platforms or establishments, consent to us (including our other corporate entities, 
                    affiliates, lending partners, technology partners, marketing channels, business partners and other third parties 
                    like credit bureaus ) to contact you through SMS, instant messaging apps, call and/or e-mail for the purposes 
                    specified in this Privacy Policy.</p>
                    <h4>Grievance Officer</h4>
                <p>In accordance with Information Technology Act 2000 and rules made there under, the name and contact details of the Grievance 
                    Officer are provided below:</p>
                    <h4>Customer Support</h4>
                <p>If you have a query, concern, or complaint in relation to collection or usage of your personal data under this Privacy 
                    Policy, You can reach our customer support team to address any of your queries or complaints please contact us 
                    at <b>support@buyandwin.in</b></p>
                <h6>Disclaimer: In case of any discrepancy or difference, the English version will take precedence over the translation</h6>
            </div>
        </Container></div>
    )
}

export default PrivacyPolicy